(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-hero-slider"] && !window.DesignMode) return;
  try {
    
  let heroSwiper;
  function initHeroSlider() {
    const slider = document.querySelector('.custom-hero-slider');
    if (!slider) return;

    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    heroSwiper = new Swiper(slider, {
      loop: true,
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  }

  document.addEventListener('DOMContentLoaded', initHeroSlider);
  document.addEventListener('shopify:section:load', initHeroSlider);
  document.addEventListener('shopify:block:select', function (event) {
    const blockId = event.detail.blockId;
    let slides = document.querySelectorAll('.swiper-slide');
    slides.forEach( slide => {
      if(blockId === JSON.parse(slide.dataset.shopifyEditorBlock).domId) {
        heroSwiper.slideToLoop(slide.dataset.swiperSlideIndex)
      }
    })
});

  } catch(e) { console.error(e); }
})();
})();
